import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box } from 'rebass'
import IconCitygateChevron from '../../../vectors/IconCitygateChevron'
import media from '../../../utils/style'

const CardWrapper = styled.a`
  overflow: hidden;
  position: relative;
  display: flex;
  width: 100%;
  text-decoration: none;

  border-radius: 20px;

  :hover,
  :focus,
  :active {
    .AutomotiveCard__Image {
      img {
        transform: scale(1.1);
        transition: transform 0.2s ease-in-out;
      }
    }

    svg {
      transform: translateX(5px);
      transition: transform 0.2s ease-in-out;
    }
  }

  ${media.MediumScreenUp`
    flex-direction: column;
  `}
`

const CardImage = styled(Box)`
  position: relative;
  aspect-ratio: 1;
  flex-basis: 90px;
  min-width: 90px;
  overflow: hidden;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: 0;
    transition: transform 0.1s ease-in-out;
  }

  ${media.MediumScreenUp`
    flex-basis: auto;
  `}
`

const CardContent = styled(Box)`
  display: flex;
  flex: 1 1 auto;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  padding: 25px 20px;
  background: ${(props) => props.backgroundColor};
  color: ${(props) => props.textColor};

  svg {
    color: white;
    opacity: 0.9;
    flex-shrink: 0;
    width: 23px;
    height: 27px;
    transition: transform 0.2s ease-in-out;
    background-blend-mode: overlay;
  }

  ${media.SmallishScreenUp`
    padding: 30px 20px 30px 25px;
    svg {
      flex-shrink: 0;
      width: 33px;
      height: 39px;
    }
  `}

  ${media.MediumScreenUp`
    align-items: flex-start;
  `}
`

const CardTitle = styled.h3`
  font-size: 0.9375rem;
  font-weight: 700;
  color: inherit;
  margin: 0;
  color: ${(props) => props.textColor};

  ${media.SmallishScreenUp`
    font-size: 1rem;
  `}
`

const AutomotiveCard = ({ title, image, backgroundColor, textColor, href }) => {
  return (
    <CardWrapper href={href} className="AutomotiveCard">
      <CardImage className="AutomotiveCard__Image">
        <img src={image} alt={title} />
      </CardImage>
      <CardContent
        backgroundColor={backgroundColor}
        className="AutomotiveCard__Content"
      >
        <CardTitle textColor={textColor}>{title}</CardTitle>
        <IconCitygateChevron width={33} height={39} color={textColor} />
      </CardContent>
    </CardWrapper>
  )
}

AutomotiveCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired
}

export default AutomotiveCard
